import { PermissionsErrorState } from '@airwallex/core/dist/page-state';
import TaskFlow from '@airwallex/core/dist/taskflow';
import {
  ERROR_CODE,
  redirectToErrorUrl,
} from '@airwallex-dev-scale/core/dist/hosted-flow-utils';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';

import { PageLoading } from '@/components/fullPage';
import { getAwxReferrerLinkOrDashboard } from '@/utils/helper';

import { useAppFlowContext } from '../appFlow';
import { useContainerHistory } from '../containerHistory';
import { ContainerContext } from '../containerProps';
import { usePaStateMachine } from './paState';

export const PermissionWrapper: FC<{}> = ({ children }:any) => {
  const { isEmbedded, isNativeHosted } = useAppFlowContext();
  const { eventEmitter, account } = useContext(ContainerContext);

  const {
    isAccessible: isAccessibleFromPa,
    loading,
    isError,
  } = usePaStateMachine();

  const isAccessibleFromAccountService = account?.status !== 'FROZEN';

  const isAccessible = isAccessibleFromPa && isAccessibleFromAccountService;

  useEffect(() => {
    if (!loading && !isAccessible && isNativeHosted) {
      redirectToErrorUrl(new Error(ERROR_CODE.UNAUTHORISED));
      return;
    }

    if (isError) {
      if (isEmbedded) {
        eventEmitter?.emit('error', { code: 'PERMISSION_DENIED' });
      }

      if (isNativeHosted) {
        redirectToErrorUrl(new Error(ERROR_CODE.UNAUTHORISED));
      }
    }
  }, [isAccessible, isNativeHosted, loading]);

  if (loading) {
    return <PageLoading data-test="page-loading" />;
  }

  /**
   * Permission check fail means the current login user does not have permission to access KYB flow
   */
/*   if (!isAccessible) {
    return <PermissionsErrorPage />;
  } */

  return <>{children}</>;
};

export const PermissionsErrorPage = () => {
  const { isEmbedded, hideHeader, langKey } = useAppFlowContext();
  const { eventEmitter } = useContext(ContainerContext);
  const containerHistory = useContainerHistory();

  return (
    <TaskFlow.Container>
      {!hideHeader && (
        <TaskFlow.Header
          heading=""
          onExit={() => {
            if (isEmbedded) {
              eventEmitter?.emit('cancel');
            } else {
              containerHistory.push(getAwxReferrerLinkOrDashboard());
            }
          }}
        />
      )}
      <PermissionsErrorState langKey={langKey} />
    </TaskFlow.Container>
  );
};
